/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/catalog_schema_diff" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiCatalogSchemaDiffCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiCatalogSchemaDiffProps,
  PostIntegrationsDirectCdiCatalogSchemaDiffResult,
} from "./types";

export const postIntegrationsDirectCdiCatalogSchemaDiff = reactQueryMutationAdapter(
  postIntegrationsDirectCdiCatalogSchemaDiffCacheKeys,
  (
    props: PostIntegrationsDirectCdiCatalogSchemaDiffProps
  ): Promise<PostIntegrationsDirectCdiCatalogSchemaDiffResult> => {
    return fetch("/integrations/direct/cdi/catalog_schema_diff", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
